import React, { useCallback, useState } from "react";
import { DispatchTableEvent, DispatchTransactionEvent } from "../events/events";
import {
  ShowError, confirmationDialog, 
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, 
  JSON_KEY_USER,
  JSON_KEY_ORDER_NUMBER,
  JSON_KEY_INSTRUMENT,
  EVENT_TYPE_ORDER_REQUEST_ORDER_NUMBER,
  EVENT_TYPE_ORDER_REQUEST_USER,
  DELETE_TABLE,
  USERS_ORDERS_TABLE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_ORDER_SEARCH_REQUEST } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";

const ITEM_ORDER_NUMBER = "order_number";
const ITEM_USER_AND_INSTRUMENT = "user_and_instrument";

const OrderRequestForm = ({ onClose, usersOptions, instrumentsOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   const [orderNumber, setOrderNumber] = useState("");
   const [instrumentCode, setInstrumentCode] = useState("");
   const [userCode, setUserCode] = useState("");
   const [removeExistingOrders, setRemoveExistingOrders] = useState(false);

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onUserDropDownChange = useCallback((e) => setUserCode(e.target.value), [setUserCode]);
   const onInstrumentDropDownChange = useCallback((e) => setInstrumentCode(e.target.value), [setInstrumentCode]);

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_ORDER_SEARCH_REQUEST,
      };

      switch (submitItem) {
         case ITEM_ORDER_NUMBER:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_ORDER_REQUEST_ORDER_NUMBER,
               {
                  ...base,
                  [JSON_KEY_ORDER_NUMBER]: Number(orderNumber),
               }
            );
            break;

         case ITEM_USER_AND_INSTRUMENT:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_ORDER_REQUEST_USER,
               {
                  ...base,
                  [JSON_KEY_USER]: userCode,
                  [JSON_KEY_INSTRUMENT]: instrumentCode,
               }
            );
            break;

         default:
            console.log("Order Request unknown submit item");
      }

      if (removeExistingOrders) {
         // console.log("Remove existing orders option selected.");
         DispatchTableEvent(DELETE_TABLE, USERS_ORDERS_TABLE, "");
      }
   };

   const handleOrderNumberSubmit = () => {
      if (orderNumber === undefined || !orderNumber) return ShowError("Enter order number");

      ConfirmAndSubmit({
         title: "Orders Request",
         text: `Request for order: ${orderNumber}`,
         item: ITEM_ORDER_NUMBER,
      });
      
      onClose(); // your modal close function
   };

   const handleUserAndInstrumentSubmit = () => {
      if (userCode === undefined || !userCode) return ShowError("User code is missing");
      if (instrumentCode === undefined || !instrumentCode) return ShowError("Instrument is missing");

      ConfirmAndSubmit({
         title: "Orders Request",
         text: `Request for orders, user: ${userCode} and instrument ${instrumentCode}`,
         item: ITEM_USER_AND_INSTRUMENT,
      });

      onClose(); // your modal close function
   };

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Order Request</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Order Number</Tab>
               <Tab>Trader & Instrument</Tab>
            </TabList>

            {/* Tab 1: Request by order number */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleOrderNumberSubmit)}>
               <div>
                  <InputField label="Order Number" value={orderNumber} onChange={setOrderNumber} type="number" />
               </div>

               <div >
                  <label className="form-label">
                     Remove Existing Orders { }
                     <input
                        type="checkbox"
                        style={{ transform: 'scale(2)', margin: '10px' }} 
                        checked={removeExistingOrders}
                        onChange={(e) => setRemoveExistingOrders(e.target.checked)}
                     />
                  </label>
               </div>
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Request by user and instrument */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleUserAndInstrumentSubmit)}>
               <div className="top">
                  {RenderDropdown("Trader", userCode, usersOptions, onUserDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Instrument", instrumentCode, instrumentsOptions, onInstrumentDropDownChange)}
               </div>

               <div >
                  <label className="form-label">
                     Remove Existing Orders { }
                     <input
                        type="checkbox"
                        style={{ transform: 'scale(2)', margin: '10px' }} 
                        checked={removeExistingOrders}
                        onChange={(e) => setRemoveExistingOrders(e.target.checked)}
                     />
                  </label>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
         </Tabs>
         </div>
      </div>
   );
};

export default OrderRequestForm;
